export abstract class IconType {
  public static readonly LIVE_VIDEO = 'Live Video';
  public static readonly VIDEO = 'Video';
  public static readonly IMAGE = 'Image';
  public static readonly AUDIO = 'Audio';
  public static readonly DOCUMENT = 'Document';
  public static readonly EXCHANGE = 'Exchange';
  public static readonly CLIP = 'Clip';
}
